import BaseModelAPI from '../BaseModelAPI';

export default class RepackStatusList extends BaseModelAPI {

	static entity = 'repackstatuslist'
	static entityName = 'repackstatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
